<template>
    <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">

      <div class="col-xl-10 col-lg-12 col-md-9">

        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-6 mr-auto ml-auto">
                <div class="py-5">
                  <div class="text-center">
                    <h1 class="h3 text-gray-900 mb-4">iTravelMix PABX</h1>
                  </div>
                  <form class="pb-2" @submit.prevent="authUser">
                    <div class="mb-3">
                      <label for="username">Username</label>
                      <div class="input-group">
                          <div class="input-group-prepend">
                              <font-awesome-icon :icon="['fas', 'user']" class="input-group-text" size="xs" />
                          </div>
                        <input type="text" class="form-control" id="username" v-model="username" required>
                      </div>
                    </div>

                    <div class="mb-3">
                        <label for="password">Password</label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                              <font-awesome-icon :icon="['fas', 'key']" class="input-group-text" size="xs" />
                          </div>
                          <input type="password" class="form-control" id="password" v-model="password" required>
                        </div>
                    </div>
                    <div v-if="error" class="alert alert-danger alert-dismissible fade show" role="alert">
                        {{ error }}
                    </div>
                    <div v-if="submited" class="text-center">
                      <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                    <button v-else class="btn btn-primary btn-lg btn-block mt-4" type="submit" :disabled="!formIsValid">Login</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Login',
  data: () => ({
    submited: false,
    username: '',
    password: '',
  }),
  computed:  {
    ...mapGetters([
      'error',
    ]),
    formIsValid() {
      return this.username.trim().length > 0 && this.password.length > 0;
    }
  },
  methods: {
    authUser() {
      this.submited = true;
      this.$store.dispatch('login', {'username': this.username, 'password': this.password})
      .then(() => {
        if (!this.error) {
          this.$router.push({'name': 'status'});
        }
        this.submited = false;
      })
      .catch(() => this.submited = false);
    }
  }
}
</script>